import { CaretLeft, IconProps } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Link, LinkProps } from 'theSource/components';

export interface BackLinkProps extends Omit<LinkProps, 'value'> {
  backLinkValue?: string;
  defaultPath?: string;
  path?: string;
  fixedPath?: string;
  capitalize?: boolean;
  internal?: boolean;
  testId?: string;
  underline?: boolean;
  disabled?: boolean;
  scrollToBenefit?: string;
  IconComponent?: React.ForwardRefExoticComponent<
    IconProps & React.RefAttributes<SVGSVGElement>
  >;
}
export const BackLink = ({
  backLinkValue,
  testId = 'back-link',
  underline = false,
  disabled = false,
  IconComponent = CaretLeft,
  className,
  scrollToBenefit,
  defaultPath = '',
  fixedPath = '',
  ...props
}: BackLinkProps) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const location = useLocation();
  const doesAnyHistoryEntryExist = location.key !== 'default';
  const navState = scrollToBenefit ? { scrollToBenefit } : undefined;
  const handleBackButton = (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (fixedPath !== '') {
      navigate(fixedPath, { state: navState });
    } else if (doesAnyHistoryEntryExist) {
      navigate(-1);
    } else if (defaultPath !== '') {
      navigate(defaultPath, {state: navState});
    }
  };
  return (
    <nav aria-label={t('common:navigateToPrevious')}>
      <Link
        {...props}
        internal
        value={backLinkValue ? backLinkValue : t('back')}
        underline={underline}
        IconComponent={IconComponent}
        testId={testId}
        className={className}
        disabled={disabled}
        onClick={handleBackButton}
      />
    </nav>
  );
};
